import { DepartmentModel } from 'api/dto/Department.dto';
import { TrendQuestion } from 'repository/TrendItemsRepository';

export const STORE_NAME = 'trendItems';

export namespace TrendItemsState {
  export type Domain = {
    list: TrendQuestion[];
    departments: DepartmentModel[];
  };

  export const INITIAL_DOMAIN: Domain = {
    list: [],
    departments: [],
  };
}
